const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    fill: "currentColor",
    viewBox: "0 0 64 64",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.948
    },
    fill: "#5664eb",
    d: "M 10.5,1.5 C 24.504,1.33343 38.504,1.50009 52.5,2C 56.6667,3.5 59.5,6.33333 61,10.5C 61.6667,24.5 61.6667,38.5 61,52.5C 59.5,56.6667 56.6667,59.5 52.5,61C 38.5,61.6667 24.5,61.6667 10.5,61C 6.33333,59.5 3.5,56.6667 2,52.5C 1.33333,38.5 1.33333,24.5 2,10.5C 3.68784,6.31481 6.52117,3.31481 10.5,1.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafe",
    d: "M 22.5,15.5 C 25.2594,16.8852 28.2594,17.5519 31.5,17.5C 43.0682,13.7908 49.9016,18.1241 52,30.5C 52.6667,34.5 52.6667,38.5 52,42.5C 49.1105,44.6345 45.9439,46.3011 42.5,47.5C 38.6224,45.5992 38.6224,43.7659 42.5,42C 42.1667,41.8333 41.8333,41.6667 41.5,41.5C 34.8333,44.1667 28.1667,44.1667 21.5,41.5C 21.1667,41.6667 20.8333,41.8333 20.5,42C 24.4029,44.0619 24.2362,45.8952 20,47.5C 16.9449,46.3895 14.1116,44.8895 11.5,43C 9.13624,33.0882 11.4696,24.4216 18.5,17C 20.0581,16.79 21.3915,16.29 22.5,15.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a61eb",
    d: "M 22.5,29.5 C 28.4877,29.664 29.821,32.164 26.5,37C 22.9447,38.1225 20.9447,36.7892 20.5,33C 20.9783,31.6974 21.645,30.5307 22.5,29.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c63ec",
    d: "M 36.5,29.5 C 42.4877,29.664 43.821,32.164 40.5,37C 36.9447,38.1225 34.9447,36.7892 34.5,33C 34.9783,31.6974 35.645,30.5307 36.5,29.5 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.55b67384210861534b248cc3b8303cd7.svg";
export { ForwardRef as ReactComponent };